<template>
  <a-drawer :maskClosable="false" width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose"
    :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />

    <a-form-model ref="form" :model="form" :rules="rules">
      <template v-if="showTtitle == 1">
        <a-form-model-item label="转账类型">
          <a-radio-group v-model="showId" button-style="solid" @change="handleChange">
            <a-radio-button :value="1"> 金豆转账 </a-radio-button>
            <a-radio-button :value="2"> 积分转账 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <!-- 
        <a-form-model-item label="收款方手机号	" prop="phone">
          <div class="yanzheg">
            <a-input v-model="form.phone" placeholder="请输入" :maxLength="11" />
            <a-button type="primary" :loading="submitLoading" @click="handjleYan" style="margin-left: 20px">
              验证
            </a-button>
          </div>
        </a-form-model-item> -->
      </template>
      <a-form-model-item label="收款方姓名" prop="nickName" v-if="nickName">
        <div class="yanzheg">
          <a-input v-model="nickName" disabled placeholder="请输入" :maxLength="50" />
        </div>
      </a-form-model-item>
      <a-form-model-item :label="showId == 1 ? '金豆' : '积分'" prop="money">
        <a-input v-model="form.money" oninput="value=value.replace(/[^-\d]/g,'')" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="备注说明	" prop="flowExplain">
        <a-input v-model="form.flowExplain" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'

import { addObj, addObj1, phoneNorMal } from '@/api/pressure/fund'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入收款方手机号'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的收款方手机号'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      showLoading: false,
      showTtitle: 1,
      showId: '',
      data: [],
      formTitle: '',
      nickName: '',
      // 表单参数
      form: {
        id: undefined,
        money: undefined,
        phone: '',
        flowExplain: undefined,
      },
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
    rules() {
      return {
        phone: [
          { required: true, message: '请输入收款方手机号', trigger: 'blur' },
          { validator: this.validatePhone, trigger: 'change' },
        ],
        money: [
          {
            required: true,
            message: this.showId == 1 ? '请输入金豆' : '请输入积分',
            trigger: 'blur',
          },
        ],
        flowExplain: [{ required: true, message: '请输入备注说明', trigger: 'blur' }],
      }
    },
  },
  watch: {},
  methods: {
    // 点击选择数据
    handleChange(e) {
      console.log(e, '测试数据===');
      // this.$refs.form.validateField('money')
      this.$refs.form.clearValidate('money')

    },
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() { },
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        devCode: undefined,
        devName: undefined,
        tenantFirmId: undefined,
        remark: undefined,
        phone: '',
        sort: 99,
      }
    },
    // 点击验证
    handjleYan() {
      if (!this.form.phone) {
        this.showLoading = true
        this.$nextTick(() => {
          this.$refs.LoadingPop.init(2, ['请输入收款方手机号'])
        })
      } else {
        const fieldsToValidate = ['phone'] // 需要验证的字段名
        let validated = 0
        let allValid = true
        // 逐个验证字段
        fieldsToValidate.forEach((field) => {
          this.$refs.form.validateField(field, (error) => {
            validated++
            if (error) {
              // console.log(`${field} 验证失败`, error)
              allValid = false
            }
            // 当所有字段都验证完成后
            if (validated === fieldsToValidate.length) {
              if (allValid) {
                console.log('所有必填字段已填写完成')
                phoneNorMal({ phoneNumber: this.form.phone }).then((res) => {
                  console.log(res, '点点滴')
                  res = res.data
                  this.form.userId = res.id
                  this.nickName = res.nickName
                })
              } else {
                console.log('部分必填字段未填写')
              }
            }
          })
        })
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.formTitle = '资金转账'
      this.showTtitle = 1
      this.showId = 1
      this.reset()
      this.open = true
      this.nickName = ''
    },
    init(id) {
      // this.showTtitle = '调整资金'
      // this.showId = 1
      // this.open = true
      this.formTitle = '调整资金'
      this.showTtitle = 1
      this.showId = 1
      this.reset()
      this.open = true
      this.form = {
        userId: id,
        money: undefined,
        flowExplain: undefined,
      }
      // this.nickName = ''
    },
    /** 修改按钮操作 */
    handleUpdate(row, type) {
      this.showId = type
      this.showTtitle = 2
      this.nickName = ''
      this.form = {
        userId: row.userId,
        money: undefined,
        flowExplain: undefined,
      }
      console.log(this.form, ' this.form')

      if (type == 1) {
        this.formTitle = '调整金豆'
      } else {
        this.formTitle = '调整积分'
      }

      this.open = true
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')
      if (!this.form.userId) return this.$message.error('请输入正确的转账账号')
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.showId == 1) {
            addObj(this.form)
              .then((response) => {
                if (this.showTtitle == 1) {
                  this.$message.success('转账成功', 3)
                } else {
                  this.$message.success('调整成功', 3)
                }
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            addObj1(this.form)
              .then((response) => {
                if (this.showTtitle == 1) {
                  this.$message.success('转账成功', 3)
                } else {
                  this.$message.success('调整成功', 3)
                }
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          console.log(messages, 'messagesmessages')

          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.yanzheg {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
